export default __webpack_public_path__ + "static/media/phone.5f516321.png";